import * as R from 'ramda'

const userToApi = (params) => {
  return {
    'user_account': {
      'company': params['companyName'],
      'email': params['emailAddress'],
      'password': params['password'],
      'username': params['userName'],
      'terms_of_service_accepted': params['acceptTosPp'],
      'privacy_policy_accepted': params['acceptTosPp']
    }
  }
}

const emailVerificationToApi = (params) => {
  return {
    'email_verification': {
      'email': params['email'],
      'token': params['token']
    }
  }
}

const userToStore = (payload) => {
  return {
    userName: payload['user']['name'],
    companyName: payload['user']['company'],
    authToken: payload['user']['token'],
    signedIn: payload['user']['signed_in']
  }
}

const otherIncomeToStore = (data) => {
  const payload = data['payload']
  return {
    description: payload['description'],
    price: payload['price']
  }
}

const otherIncomeToApi = (params) => {
  return {
    'other_income': {
      'id': params['id'],
      'description': params['item']['description'],
      'price': params['item']['price'],
      'default_quantity': params['item']['defaultQuantity']
    }
  }
}

const cropCommodityToStore = (data) => {
  return {}
}

const cropCommodityToApi = (params) => {
  return {
    'crop_commodity': {
      'id': params['id'],
      'crop_id': params['item']['cropId'],
      'commodity_id': params['item']['commodityId'],
      'production': params['item']['production']
    }
  }
}

const cropCommodityUpdateProductionToApi = (params) => {
  return {
    'crop_commodity': {
      'id': params['itemId'],
      'production': params['production']
    }
  }
}

const cropOtherIncomeToStore = (data) => {
  return {}
}

const cropOtherIncomeToApi = (params) => {
  return {
    'crop_other_income': {
      'id': params['id'],
      'crop_id': params['item']['cropId'],
      'other_income_id': params['item']['otherIncomeId'],
      'quantity': params['item']['quantity']
    }
  }
}

const cropOtherIncomeUpdateQuantityToApi = (params) => {
  return {
    'crop_other_income': {
      'id': params['itemId'],
      'quantity': params['quantity']
    }
  }
}

const cropSeedToStore = (data) => {
  return {}
}

const cropSeedToApi = (params) => {
  return {
    'crop_seed': {
      'id': params['id'],
      'crop_id': params['item']['cropId'],
      'seed_id': params['item']['seedId'],
      'seeding_rate': params['item']['seedingRate']
    }
  }
}

const cropSeedUpdateSeedingRateToApi = (params) => {
  return {
    'crop_seed': {
      'id': params['itemId'],
      'seeding_rate': params['seedingRate']
    }
  }
}

const cropCustomRateToStore = (data) => {
  return {}
}

const cropOtherExpenseToStore = (data) => {
  return {}
}

const cropOtherExpenseToApi = (params) => {
  return {
    'crop_other_expense': {
      'id': params['id'],
      'crop_id': params['item']['cropId'],
      'other_expense_id': params['item']['otherExpenseId'],
      'quantity': params['item']['quantity']
    }
  }
}

const cropCustomRateToApi = (params) => {
  return {
    'crop_custom_rate': {
      'id': params['id'],
      'crop_id': params['item']['cropId'],
      'custom_rate_id': params['item']['customRateId'],
      'quantity': params['item']['quantity']
    }
  }
}

const cropCustomRateUpdateQuantityToApi = (params) => {
  return {
    'crop_custom_rate': {
      'id': params['itemId'],
      'quantity': params['quantity']
    }
  }
}

const cropOtherExpenseUpdateQuantityToApi = (params) => {
  return {
    'crop_other_expense': {
      'id': params['itemId'],
      'quantity': params['quantity']
    }
  }
}

const cropChemicalToStore = (data) => {
  return {}
}

const cropChemicalToApi = (params) => {
  return {
    'crop_chemical': {
      'id': params['id'],
      'crop_id': params['item']['cropId'],
      'chemical_id': params['item']['chemicalId'],
      'application_rate': params['item']['applicationRate']
    }
  }
}

const cropChemicalUpdateApplicationRateToApi = (params) => {
  return {
    'crop_chemical': {
      'id': params['itemId'],
      'application_rate': params['applicationRate']
    }
  }
}

const cropFertilizerToStore = (data) => {
  return {}
}

const cropFertilizerToApi = (params) => {
  return {
    'crop_fertilizer': {
      'id': params['id'],
      'crop_id': params['item']['cropId'],
      'fertilizer_id': params['item']['fertilizerId'],
      'application_rate': params['item']['applicationRate']
    }
  }
}

const cropFertilizerUpdateApplicationRateToApi = (params) => {
  return {
    'crop_fertilizer': {
      'id': params['itemId'],
      'application_rate': params['applicationRate']
    }
  }
}

const cropIrrigationToStore = (data) => {
  return {}
}

const cropIrrigationToApi = (params) => {
  return {
    'crop_irrigation': {
      'id': params['id'],
      'crop_id': params['item']['cropId'],
      'irrigation_id': params['item']['irrigationId'],
      'quantity': params['item']['quantity']
    }
  }
}

const cropIrrigationUpdateQuantityToApi = (params) => {
  return {
    'crop_irrigation': {
      'id': params['itemId'],
      'quantity': params['quantity']
    }
  }
}

const commodityToStore = (data) => {
  const payload = data['payload']
  return {
    description: payload['description'],
    price: payload['price']
  }
}

const commodityToApi = (params) => {
  return {
    'commodity': {
      'id': params['id'],
      'description': params['item']['description'],
      'price': params['item']['price'],
      'default_production': params['item']['defaultProduction']
    }
  }
}

const fertilizerToStore = (data) => {
  const payload = data['payload']
  return {
    description: payload['description'],
    cost: payload['cost']
  }
}

const fertilizerToApi = (params) => {
  return {
    'fertilizer': {
      'id': params['id'],
      'description': params['item']['description'],
      'convert_unit_id': params['item']['convertUnitId'],
      'cost': params['item']['cost'],
      'default_application_rate': params['item']['defaultApplicationRate']
    }
  }
}

const chemicalToStore = (data) => {
  const payload = data['payload']
  return {
    description: payload['description'],
    cost: payload['cost']
  }
}

const chemicalToApi = (params) => {
  return {
    'chemical': {
      'id': params['id'],
      'description': params['item']['description'],
      'convert_unit_id': params['item']['convertUnitId'],
      'cost': params['item']['cost'],
      'default_application_rate': params['item']['defaultApplicationRate']
    }
  }
}

const irrigationToStore = (data) => {
  const payload = data['payload']
  return {
    description: payload['description'],
    cost: payload['cost']
  }
}

const irrigationToApi = (params) => {
  return {
    'irrigation': {
      'id': params['id'],
      'description': params['item']['description'],
      'cost': params['item']['cost'],
      'default_quantity': params['item']['defaultQuantity']
    }
  }
}

const customRateToStore = (data) => {
  const payload = data['payload']
  return {
    description: payload['description'],
    cost: payload['cost']
  }
}

const customRateToApi = (params) => {
  return {
    'custom_rate': {
      'id': params['id'],
      'description': params['item']['description'],
      'cost': params['item']['cost'],
      'default_quantity': params['item']['defaultQuantity']
    }
  }
}

const otherExpenseToStore = (data) => {
  const payload = data['payload']
  return {
    description: payload['description'],
    cost: payload['cost']
  }
}

const otherExpenseToApi = (params) => {
  return {
    'other_expense': {
      'id': params['id'],
      'description': params['item']['description'],
      'cost': params['item']['cost'],
      'default_quantity': params['item']['defaultQuantity']
    }
  }
}

const seedToStore = (data) => {
  const payload = data['payload']
  return {
    description: payload['description'],
    costPerUnit: payload['cost_per_unit']
  }
}

const seedToApi = (params) => {
  return {
    'seed': {
      'id': params['id'],
      'description': params['item']['description'],
      'seeds_per_unit': params['item']['seedsPerUnit'],
      'cost_per_unit': params['item']['costPerUnit'],
      'default_seeding_rate': params['item']['defaultSeedingRate']
    }
  }
}

const cropToStore = (data) => {
  const payload = data['payload']
  return {
    description: payload['description']
  }
}

const cropToApi = (params) => {
  return {
    'crop': {
      'id': params['id'],
      'description': params['item']['description']
    }
  }
}

const defaultDataToStore = (payload) => {
  const commodities = payload['commodities']
  const customRates = payload['custom_rates']
  const seeds = payload['seeds']
  const irrigation = payload['irrigation']
  const otherIncomes = payload['other_incomes']
  const otherExpenses = payload['other_expenses']
  const convertUnits = payload['convert_units']
  const chemicals = payload['chemicals']
  const fertilizers = payload['fertilizers']

  const crops = payload['crops']
  const cropsFertilizers = payload['crops_fertilizers']
  const cropsChemicals = payload['crops_chemicals']
  const cropsCustomRates = payload['crops_custom_rates']
  const cropsSeeds = payload['crops_seeds']
  const cropsIrrigations = payload['crops_irrigations']
  const cropsOtherExpenses = payload['crops_other_expenses']

  const cropsCommodities = payload['crops_commodities']
  const cropsOtherIncomes = payload['crops_other_incomes']

  const filterByCropId = (cropId, items) => R.filter((item) => {
    return item.crop_id === cropId
  }, items)

  const onlyIds = (items) => R.map((item) => {
    return item['id']
  }, items)

  const commoditiesForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        description: item['description'],
        price: parseFloat(item['price']),
        defaultProduction: parseFloat(item['default_production'])
      }
    }
    return {...acc, ...tempItem}
  }, {}, commodities)

  const customRatesForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        description: item['description'],
        cost: parseFloat(item['cost']),
        defaultQuantity: parseFloat(item['default_quantity'])
      }
    }
    return {...acc, ...tempItem}
  }, {}, customRates)

  const otherExpensesForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        description: item['description'],
        cost: parseFloat(item['cost']),
        defaultQuantity: parseFloat(item['default_quantity'])
      }
    }
    return {...acc, ...tempItem}
  }, {}, otherExpenses)

  const seedsForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        description: item['description'],
        costPerUnit: parseFloat(item['cost_per_unit']),
        seedsPerUnit: parseFloat(item['seeds_per_unit']),
        defaultSeedingRate: parseFloat(item['default_seeding_rate'])
      }
    }
    return {...acc, ...tempItem}
  }, {}, seeds)

  const irrigationForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        description: item['description'],
        cost: parseFloat(item['cost']),
        defaultQuantity: parseFloat(item['default_quantity'])
      }
    }
    return {...acc, ...tempItem}
  }, {}, irrigation)

  const otherIncomesForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        description: item['description'],
        price: parseFloat(item['price']),
        defaultQuantity: parseFloat(item['default_quantity'])
      }
    }
    return {...acc, ...tempItem}
  }, {}, otherIncomes)

  const convertUnitsForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        fromUnit: item['from_unit'],
        toUnit: item['to_unit'],
        sortOrder: item['sort_order'],
        quantity: parseFloat(item['quantity'])
      }
    }
    return {...acc, ...tempItem}
  }, {}, convertUnits)

  const chemicalsForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        description: item['description'],
        cost: parseFloat(item['cost']),
        defaultApplicationRate: parseFloat(item['default_application_rate']),
        convertUnitId: item['convert_unit_id']
      }
    }
    return {...acc, ...tempItem}
  }, {}, chemicals)

  const fertilizersForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        description: item['description'],
        cost: parseFloat(item['cost']),
        defaultApplicationRate: parseFloat(item['default_application_rate']),
        convertUnitId: item['convert_unit_id']
      }
    }
    return {...acc, ...tempItem}
  }, {}, fertilizers)

  const cropsForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        description: item['description'],
        expenseCustomRateItems: onlyIds(filterByCropId(item['id'], cropsCustomRates)),
        expenseChemicalItems: onlyIds(filterByCropId(item['id'], cropsChemicals)),
        expenseFertilizerItems: onlyIds(filterByCropId(item['id'], cropsFertilizers)),
        expenseSeedItems: onlyIds(filterByCropId(item['id'], cropsSeeds)),
        expenseIrrigationItems: onlyIds(filterByCropId(item['id'], cropsIrrigations)),
        expenseOtherExpenseItems: onlyIds(filterByCropId(item['id'], cropsOtherExpenses)),
        incomeCommodityItems: onlyIds(filterByCropId(item['id'], cropsCommodities)),
        incomeOtherIncomeItems: onlyIds(filterByCropId(item['id'], cropsOtherIncomes))
      }
    }

    return {...acc, ...tempItem}
  }, {}, crops)

  const cropsFertilizersForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        cropId: item['crop_id'],
        fertilizerId: item['fertilizer_id'],
        applicationRate: item['application_rate']
      }
    }

    return {...acc, ...tempItem}
  }, {}, cropsFertilizers)

  const cropsChemicalsForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        cropId: item['crop_id'],
        chemicalId: item['chemical_id'],
        applicationRate: item['application_rate']
      }
    }

    return {...acc, ...tempItem}
  }, {}, cropsChemicals)

  const cropsCustomRatesForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        cropId: item['crop_id'],
        customRateId: item['custom_rate_id'],
        quantity: item['quantity']
      }
    }

    return {...acc, ...tempItem}
  }, {}, cropsCustomRates)

  const cropsOtherExpensesForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        cropId: item['crop_id'],
        otherExpenseId: item['other_expense_id'],
        quantity: item['quantity']
      }
    }

    return {...acc, ...tempItem}
  }, {}, cropsOtherExpenses)

  const cropsSeedsForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        cropId: item['crop_id'],
        seedId: item['seed_id'],
        seedingRate: item['seeding_rate']
      }
    }

    return {...acc, ...tempItem}
  }, {}, cropsSeeds)

  const cropsIrrigationsForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        cropId: item['crop_id'],
        irrigationId: item['irrigation_id'],
        quantity: item['quantity']
      }
    }

    return {...acc, ...tempItem}
  }, {}, cropsIrrigations)

  const cropsCommoditiesForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        cropId: item['crop_id'],
        commodityId: item['commodity_id'],
        production: item['production']
      }
    }

    return {...acc, ...tempItem}
  }, {}, cropsCommodities)

  const cropsOtherIncomesForStore = R.reduce((acc, item) => {
    const tempItem = {
      [item['id']]: {
        cropId: item['crop_id'],
        otherIncomeId: item['other_income_id'],
        quantity: item['quantity']
      }
    }

    return {...acc, ...tempItem}
  }, {}, cropsOtherIncomes)

  return {
    commodities: commoditiesForStore,
    customRates: customRatesForStore,
    otherExpenses: otherExpensesForStore,
    seeds: seedsForStore,
    irrigation: irrigationForStore,
    otherIncomes: otherIncomesForStore,
    convertUnits: convertUnitsForStore,
    chemicals: chemicalsForStore,
    fertilizers: fertilizersForStore,
    crops: cropsForStore,
    cropsFertilizers: cropsFertilizersForStore,
    cropsChemicals: cropsChemicalsForStore,
    cropsCustomRates: cropsCustomRatesForStore,
    cropsOtherExpenses: cropsOtherExpensesForStore,
    cropsSeeds: cropsSeedsForStore,
    cropsIrrigations: cropsIrrigationsForStore,
    cropsCommodities: cropsCommoditiesForStore,
    cropsOtherIncomes: cropsOtherIncomesForStore
  }
}

const mapApiToFronted = {
  emailVerificationToApi,
  defaultDataToStore,
  userToStore,
  userToApi,
  fertilizerToStore,
  fertilizerToApi,
  chemicalToStore,
  chemicalToApi,
  customRateToStore,
  customRateToApi,
  otherExpenseToStore,
  otherExpenseToApi,
  seedToStore,
  seedToApi,
  irrigationToStore,
  irrigationToApi,
  commodityToStore,
  commodityToApi,
  otherIncomeToStore,
  otherIncomeToApi,
  cropToStore,
  cropToApi,
  cropCommodityToStore,
  cropCommodityToApi,
  cropCommodityUpdateProductionToApi,
  cropOtherIncomeToStore,
  cropOtherIncomeToApi,
  cropOtherIncomeUpdateQuantityToApi,
  cropSeedToStore,
  cropSeedToApi,
  cropSeedUpdateSeedingRateToApi,
  cropCustomRateToStore,
  cropCustomRateToApi,
  cropOtherExpenseToStore,
  cropOtherExpenseToApi,
  cropCustomRateUpdateQuantityToApi,
  cropOtherExpenseUpdateQuantityToApi,
  cropChemicalToStore,
  cropChemicalToApi,
  cropChemicalUpdateApplicationRateToApi,
  cropFertilizerToStore,
  cropFertilizerToApi,
  cropFertilizerUpdateApplicationRateToApi,
  cropIrrigationToStore,
  cropIrrigationToApi,
  cropIrrigationUpdateQuantityToApi
}

export default mapApiToFronted
